export const CORE_LAUNCH_PATHS = new Set([
  '/',
  '/vendor-requests',
  '/vendor-requests/:id',
  '/resident-approvals',
  '/review-approvals',
  '/vendor-ads',
  '/ad-pricing',
  '/profiles',
  '/profiles/:id',
  '/categories',
  '/categories/:id',
  '/categories/add',
  '/edit-category/:id',
  '/payment-logs',
  '/statistics',
  '/push-notifications',
  '/neighborhoods',
  '/neighborhoods/create',
  '/neighborhoods/view/:id',
  '/admin-management',
  '/admins',
  '/admins/create',
  '/family-management',
  '/family-management/create',
  '/family-management/details/:id',
  '/family-management/location/:id',
  '/rangefinder',
  '/rangefinder/path-editor',
  '/rangefinder/landmark-manager',
  '/rangefinder/route-tester',
  '/content-moderation',
  '/profile',
  '/profile/edit-profile',
  '/profile/change-password',
  '/notifications',
  '/login',
  '/forget-password',
  '/forget-password2',
  '/forget-password3',
  '*',
]);

export const isLaunchEnabledPath = (path) => CORE_LAUNCH_PATHS.has(path);
